import { useState, useEffect } from "react";
import "../../style/components/wrk.css";
import Background from "../container/Background";
import Glass from "../container/Glass";
import firebase from "../../database/firebase";
import { Link, Switch, Route } from "react-router-dom";
import Playep from "./Playep";

export default function Play() {
  let [plays, set_plays] = useState([]);

  useEffect(() => {
    document.title = "Play Ground";
    firebase
      .firestore()
      .collection("play-ground")
      .orderBy("order", "desc")
      .get()
      .then((r) => {
        let all = r.docs.map((r) => {
          return { ...r.data() };
        });
        set_plays(all);
      });
  }, []);
  function items() {
    return plays.map((r, i) => {
      return (
        <div key={i}>
          <Link to={"/play-ground/" + r.order}>
            <center>
              <img src={r.image} alt="wena" />
              <span>{r.title}</span>
            </center>
          </Link>
        </div>
      );
    });
  }
  return (
    <div>
      <Background>
        <Switch>
          <Route exact={true} path="/play-ground/:order" component={Playep} />
        </Switch>

        {window.location.pathname === "/play-ground" ? (
          <Glass>{items()}</Glass>
        ) : null}
      </Background>
    </div>
  );
}
